import React from 'react';
import './default_input.scss';

function HalfWrapper(props) {
  return (
    <div className={`half-wrapper ${props.className}`}>

      {props.children}

    </div>
  );
}

export {HalfWrapper};

function SelectOption(value, text=null) {
  return {
    value: value,
    text: text || value,
  };
}

export {SelectOption};

function DummyInput(props) {
  return (
    <div className={`dummy-input ${props.className}`}> </div>
  );
}

export {DummyInput};

function getSelectOptions(options) {
  return options.map((option) => {
    return (
      <option key={`default_input_select_option_${option.value}`} value={option.value}>{option.text}</option>
    );
  });
}

function DefaultInput(props) {
  if(props.type === 'toggle') {
    return (
      <div className={`default-input${props.isHorizontal ? '--horizontal': ''} ${props.className || ''}`}>

        {props.label ?
          <h4
            className={`default-input__label${props.invertLabel ? '--inverted' : ''} ${props.labelClassName || ''}`}
            htmlFor={`default_input_${props.name}`}
          >
            {props.label}
          </h4> :
          null
        }

        <div className={`default-input__input-wrapper${props.invertLabel ? '--inverted' : ''}`}>

          <label>

            <input
              className="default-input__toggle-input"
              id={`default_input_${props.name}`}
              name={props.name}
              aria-hidden="false"
              type="checkbox"
              checked={props.value}
              onChange={props.handleInputChange}
              onBlur={props.handleOnBlur}
              disabled={props.disabled}
            />
            <span
              className={`default-input__toggle-visual${props.neutralInactiveColor ? '--inactive-neutral' : ''}`}
              aria-hidden="true"
              inactive-text={props.inactiveText}
              active-text={props.activeText}
              toggle-width="20em"
            >

              <span></span>

            </span>

          </label>

        </div>

      </div>
    );
  }

  return (
    <div className={`default-input${props.isHorizontal ? '--horizontal': ''} ${props.className || ''}`}>

      {props.label ?
        <label
          className={`default-input__label${props.invertLabel ? '--inverted' : ''} ${props.labelClassName || ''}`}
          htmlFor={`default_input_${props.name}`}
        >
          {props.label}

          {props.labelMessage ?
            <span className="default-input__label__warning-message" style={props.labelColor ? {color: props.labelColor} : {}}>
              {props.labelMessage}
            </span>:
            null
          }
        </label> :
        null
      }

      <div className={`default-input__input-wrapper${props.invertLabel ? '--inverted' : ''}`}>

        {props.type === 'textarea' ?
          <textarea
            className={`default-input__text-area-input${props.isHighlighted ? '--highlighted' : ''}`}
            wrap="soft"
            id={`default_input_${props.name}`}
            name={props.name}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
            onChange={props.handleInputChange}
            onBlur={props.handleOnBlur}
            value={props.value}
            rows={props.rows}
            onKeyDown={props.onKeyDown}
            onFocus={props.onFocus}
            disabled={props.disabled}
          /> :
          props.type === 'select' ?
          <select
            className={`default-input__select-input${props.isHighlighted ? '--highlighted' : ''}`}
            id={`default_input_${props.name}`}
            name={props.name}
            onChange={props.handleInputChange}
            onBlur={props.handleOnBlur}
            value={props.value}
            disabled={props.disabled}
          >
            {getSelectOptions(props.options)}
          </select> :
          <input
            className={`default-input__input${props.isHighlighted ? '--highlighted' : ''}`}
            id={`default_input_${props.name}`}
            name={props.name}
            type={props.type}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
            min={props.min}
            max={props.max}
            step={props.step}
            onChange={props.handleInputChange}
            onBlur={props.handleOnBlur}
            value={props.value}
            autoComplete={props.autoComplete}
            onKeyDown={props.onKeyDown}
            onFocus={props.onFocus}
            disabled={props.disabled}
            checked={props.type === 'checkbox' && props.value}
          />
        }

        {props.prefix ?
          <span className="default-input__input-prefix">{props.prefix}</span> :
          null
        }

        {props.suffix ?
          <span className="default-input__input-suffix">{props.suffix}</span> :
          null
        }

      </div>

    </div>
  );
}

export default DefaultInput;
